import {Accordion, Row, Col} from 'react-bootstrap';
import i18n from '../../../plugins/i18n';
import { useState, useEffect } from 'react';

function IminioTechnicalInterventionListItem({ listId, interventionData, children }) {

    const [wWidth, setWindowWidth] = useState(window.innerWidth)
    // useRef ?

    useEffect(() => {
      const updateWindowDimensions = () => {
        const newWidth = window.innerWidth;
        setWindowWidth(newWidth);
      };
      window.addEventListener("resize", updateWindowDimensions);
      return () => window.removeEventListener("resize", updateWindowDimensions) 
    }, []);

    const chooseStatusColor = (status)=>{
      switch(status){
        case 'pending':     return 'fg-red'
        case 'in_progress': return 'fg-yellow'
        case 'completed':   return 'fg-orange'
        case 'closed':      return 'fg-green'
        default: return ''
      }
    }

    const chooseStatusIcon = (status)=>{
      switch(status){
        case 'pending':     return 'mdi-account-alert'
        case 'in_progress': return 'mdi-repeat'
        case 'completed':   return 'mdi-check-circle'
        case 'closed':      return 'mdi-folder-check'
        default:            return ''
      }
    }

    const fitTypeText = (codename) => {
      if(!codename) return
      let text = ''
      if(codename === 'other' && interventionData.type.type_other_name?.length > 0)
        text = interventionData.type.type_other_name
      else text = i18n.t(`models.technical_intervention.types.${codename}`)
      if(wWidth<900 && text.length > 27)
        text = text.substring(0,25)+'...'
      if(wWidth<500 && text.length > 20)
        text = text.substring(0,17)+'...'
      return text
    }

    const formatDate = (date) => {
      if(!date) return
      const split = date.split('-')
      if(split.length === 2)
        return `${split[1]}/${split[0]}`
      if(split.length === 3)
        return `${split[2]}/${split[1]}/${split[0]}`
    }

    const getCategoryIndicator = () => {
      // Mostra il bollino solo se l'intervento non è chiuso
      if(interventionData.status === 'closed') return null;
      
      const categoryCodename = interventionData.category?.codename;
      
      if(categoryCodename === 'urgent') {
        return <span className="ms-2" style={{
          display: 'inline-block',
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          backgroundColor: '#dc3545',
          verticalAlign: 'middle'
        }} title="Intervento Urgente"></span>;
      }
      
      if(categoryCodename === 'prioritary') {
        return <span className="ms-2" style={{
          display: 'inline-block',
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          backgroundColor: '#0d6efd',
          verticalAlign: 'middle'
        }} title="Intervento Prioritario"></span>;
      }
      
      return null;
    }

    return (
        <>
          <Accordion className="mb-2">
            <Accordion.Item eventKey={interventionData.id}>
              <Accordion.Header className="iminio-list-item-header" >
                  <Row className="justify-content-start align-items-center width-100">
                      <h6 className="fg-orange-dark me-3 text-7" style={{maxWidth: '10px'}}>{interventionData.id}</h6>
                      <Col xs={wWidth < 900?3:2}>
                          <span className={wWidth<900?'text-6':'text-8'}>
                            {interventionData.condominium?.name}
                            {getCategoryIndicator()}
                          </span>
                      </Col>
                      <Col xs={wWidth < 900?4:4} md={3}>
                        <span className={wWidth<900?'text-7':'text-8'}>
                          {fitTypeText(interventionData.type?.codename)}
                          {/* {i18n.t(`models.technical_intervention.types.${interventionData.type?.codename}`)} */}
                        </span>
                      </Col>
                      <Col xs={wWidth < 900?2:2} sm={2} md={1} lg={1} className={`ps-2 align-items-center justify-content-center`}>
                          <span className={`${wWidth<900?'text-6':'text-9'}`}>{formatDate(interventionData.activity_at?.substring(0,10))}</span>
                      </Col>
                      <Col xs={1} md={1} className="ps-3 d-flex align-items-center align-content-start justify-content-start" style={{maxWidth: '130px', minWidth: wWidth<900?'10px':'127px'}}>
                          <i id={`${listId}-status-icon`} className={`mdi ${chooseStatusIcon(interventionData.status)} me-1 ${chooseStatusColor(interventionData.status)}`}></i>
                          {wWidth < 900? '' :
                            (
                              interventionData?.status == null ? '' :
                              <span id={`${listId}-status-text`} className="text-8">{i18n.t(`models.technical_intervention.status.${interventionData.status}`)}</span>
                            )
                          }
                      </Col>
                      <Col xs={1} className="d-flex align-items-center align-content-start justify-content-start">
                          <span id={`${listId}-category`} className='ps-2'>
                            {
                              interventionData.category?.codename == undefined ? 
                              '' 
                              : 
                              (
                                wWidth < 900?
                                interventionData.category?.codename.substring(0,1).toUpperCase()
                                :
                                i18n.t(`models.technical_intervention.category.${interventionData.category?.codename}`)
                              )
                            }
                          </span>
                      </Col>{
                         wWidth < 900? '' :
                      <Col xs={0} md={2}>
                          <span id={`${listId}-assigned_to`}>{interventionData?.user?.first_name} {interventionData?.user?.last_name}</span>
                      </Col>}
                  </Row>
              </Accordion.Header>
              <Accordion.Body className="iminio-list-item-body">
                {children}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </>
      );
}

export default IminioTechnicalInterventionListItem